import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  NumberInput,
  useRedirect,
  useNotify,
} from 'react-admin';
import { Box, Typography } from '@mui/material';
import ResourceBreadcrumbsWithActions from '../../components/ResourceBreadcrumbsWithActions';

export const BrandCreate = () => {
  const redirect = useRedirect();
  const notify = useNotify();

  const handleSuccess = () => {
    notify('Brand created successfully');
    redirect('/brands');
  };

  return (
    <Create resource="brands" redirect={false} onSuccess={handleSuccess}>
      <SimpleForm>
        <Box sx={{ mb: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
            Create New Brand
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Add a new franchise brand to your enterprise network
          </Typography>
        </Box>

        <TextInput
          source="name"
          label="Brand Name"
          validate={[{ required: 'Brand name is required' }]}
          fullWidth
        />

        <TextInput
          source="description"
          label="Description"
          multiline
          rows={3}
          fullWidth
        />

        <TextInput
          source="industry"
          label="Industry"
          placeholder="e.g., Cleaning Services, Lawn Care"
          fullWidth
        />

        <SelectInput
          source="enterpriseId"
          label="Enterprise"
          optionText="name"
          optionValue="id"
          validate={[{ required: 'Enterprise is required' }]}
          fullWidth
        />

        <NumberInput
          source="defaultRoyaltyRate"
          label="Default Royalty Rate (%)"
          helperText="Percentage that franchisees pay (e.g., 5 for 5%)"
          step={0.1}
          fullWidth
        />
      </SimpleForm>
    </Create>
  );
};
